import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { useTable } from 'react-table';

function CollegeallEditCoursePage() {
    // Sample data for universities and courses
    const universities = [
        { id: 1, name: 'Harvard University' },
        { id: 2, name: 'Stanford University' },
        { id: 3, name: 'MIT' },
    ];

    const courses = [
        { id: 1, universityId: 1, name: 'Computer Science', duration: '4 Years', fee: '$50,000', brochure: 'link1.com', about: 'Computer Science program at Harvard University.' },
        { id: 2, universityId: 1, name: 'Law', duration: '3 Years', fee: '$45,000', brochure: 'link2.com', about: 'Law program at Harvard University.' },
        { id: 3, universityId: 2, name: 'Electrical Engineering', duration: '4 Years', fee: '$55,000', brochure: 'link3.com', about: 'Electrical Engineering at Stanford University.' },
        { id: 4, universityId: 3, name: 'Mechanical Engineering', duration: '4 Years', fee: '$60,000', brochure: 'link4.com', about: 'Mechanical Engineering at MIT.' },
    ];

    const [selectedUniversity, setSelectedUniversity] = useState(null);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);

    const handleUniversityChange = (e) => {
        const universityId = parseInt(e.target.value);
        setSelectedUniversity(universityId);

        // Filter courses by the selected university
        const filtered = courses.filter(course => course.universityId === universityId);
        setFilteredCourses(filtered);
    };

    const handleEdit = (course) => {
        setSelectedCourse(course);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setSelectedCourse(null);
    };

    // Table columns for courses
    const columns = React.useMemo(
        () => [
            {
                Header: 'Course Name',
                accessor: 'name',
            },
            {
                Header: 'Duration',
                accessor: 'duration',
            },
            {
                Header: 'Fee',
                accessor: 'fee',
            },
            {
                Header: 'Brochure Link',
                accessor: 'brochure',
                Cell: ({ value }) => <a href={value} target="_blank" rel="noopener noreferrer">View Brochure</a>,
            },
            {
                Header: 'About Course',
                accessor: 'about',
            },
            {
                Header: 'Actions',
                accessor: 'actions',
                Cell: ({ row }) => (
                    <button onClick={() => handleEdit(row.original)}>
                        Edit
                    </button>
                ),
            },
        ],
        []
    );

    // React-table hook for courses table
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
        columns,
        data: filteredCourses,
    });

    const renderEditModal = () => (
        <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
            <h2>Edit Course</h2>
            {selectedCourse && (
                <div>
                    <div>
                        <label>Course Name: </label>
                        <input
                            type="text"
                            value={selectedCourse.name}
                            onChange={(e) => setSelectedCourse({ ...selectedCourse, name: e.target.value })}
                        />
                    </div>
                    <div>
                        <label>Duration: </label>
                        <input
                            type="text"
                            value={selectedCourse.duration}
                            onChange={(e) => setSelectedCourse({ ...selectedCourse, duration: e.target.value })}
                        />
                    </div>
                    <div>
                        <label>Fee: </label>
                        <input
                            type="text"
                            value={selectedCourse.fee}
                            onChange={(e) => setSelectedCourse({ ...selectedCourse, fee: e.target.value })}
                        />
                    </div>
                    <div>
                        <label>Brochure Link: </label>
                        <input
                            type="url"
                            value={selectedCourse.brochure}
                            onChange={(e) => setSelectedCourse({ ...selectedCourse, brochure: e.target.value })}
                        />
                    </div>
                    <div>
                        <label>About Course: </label>
                        <textarea
                            value={selectedCourse.about}
                            onChange={(e) => setSelectedCourse({ ...selectedCourse, about: e.target.value })}
                        />
                    </div>
                    <div>
                        <button onClick={closeModal}>Cancel</button>
                        <button onClick={() => { alert('Course details saved!'); closeModal(); }}>Save</button>
                    </div>
                </div>
            )}
        </ReactModal>
    );

    return (
        <div className="edit-course-page">
            <h1>Edit Course Page</h1>
            <div>
                <label>Select University: </label>
                <select onChange={handleUniversityChange} value={selectedUniversity || ''}>
                    <option value="">Select University</option>
                    {universities.map((uni) => (
                        <option key={uni.id} value={uni.id}>
                            {uni.name}
                        </option>
                    ))}
                </select>
            </div>

            {selectedUniversity && filteredCourses.length > 0 && (
                <div className="course-table">
                    <table {...getTableProps()} border="1">
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => (
                                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {renderEditModal()}
        </div>
    );
}

export default CollegeallEditCoursePage;
